export class VMS_Notification {
    ID: number = 0;
    TITLE: string='NOTICE';
    SUBJECT_LINE: string;
    BODY_CONTENT: string;
    SPECIAL_NOTE: string;
    START_DATE: Date;
    END_DATE: Date;
    FREQUENCY: number = 0;
    DISPLAY_MODE: number = 0;
    DISPLAY_ORDER: number = 0;
    ATTACHMENTS: string;
    IS_ACTIVE: boolean = true;
    STATUS: string = 'PENDING';
    REMARKS: string;
    CREATED_BY: string;
    CREATED_ON: Date;
    MODIFIED_BY: string;
    MODIFIED_ON: Date;
}
